module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/feature02-67561edcfc58d4ff1ac05651b29495e3.svg";